export default {
  create: {
    title: 'Adicionar',
    subtitle: 'Jogos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Jogo',
    button: {
      add: 'Novo jogo',
    },
  },
  list: {
    title: 'Loop',
    subtitle: 'Lista',
    add: 'Novo jogo',
  },
  card: {
    title: 'Loop',
    actions: 'Ações',
  },
  table: {
    title: 'Jogos Ativos',
    searchPlaceholder: 'Procurar por algo...',
  },
  form: {
    name: {
      label: 'Nome:',
      placeholder: 'Ex: Loop Nível 1',
      invalid: 'Nome é obrigatório',
    },
    showAnswer: {
      label: 'Mostrar resposta',
    },
    colored: {
      label: 'Colorido',
    },
    columns: {
      label: 'Colunas:',
    },
    rows: {
      label: 'Linhas:',
    },
    numObstacles: {
      label: 'Quantidade de obstáculos:',
      auto: 'Automático',
      tooltipAuto: 'Sugestão ideal: {count} obstáculos para este grid.',
      tooltipManual: 'Defina a quantidade de obstáculos manualmente.',
      parityHint:
        'Para este tamanho de grid, use um número {parity} de obstáculos.',
      parityOdd: 'ÍMPAR',
      parityEven: 'PAR',
    },
    pathWeight: {
      label: 'Espessura das Linhas:',
      thin: 'Fina',
      normal: 'Normal',
      bold: 'Espessa',
    },
    prioritizeQuality: {
      label: 'Qualidade Visual',
      enabled: 'Ativado',
      tooltip:
        'Gera várias opções e escolhe a que tem a melhor distribuição no grid. Pode demorar mais tempo.',
    },
    fastGeneration: {
      label: 'Geração Rápida',
      enabled: 'Ativado',
      tooltipLarge:
        'Ativado automaticamente: Grids maiores que 8x8 exigem este algoritmo otimizado para gerar instantaneamente e evitar travamentos.',
      tooltip:
        'Usa um algoritmo otimizado para gerar instantaneamente. Tem um padrão mais geométrico.',
    },
  },
  button: {
    generate: 'Gerar Jogo',
  },
  sidebar: {
    exportHint: 'Você precisa salvar antes de exportar.',
    defaultFileName: 'puzzle-loop',
  },
  alert: {
    firstLoopFound: 'Primeiro Loop encontrado!',
    perfectLoopFound: 'Loop perfeito encontrado!',
    bestOptionFound: 'Melhor opção encontrada!',
    generateFailed:
      'Não foi possível gerar um loop fechado. Tente alterar os obstáculos.',
    workerError: 'Erro no worker {index}: {message}',
    workerCritical: 'Falha crítica em um Worker.',
    gameSaved: 'Jogo salvo com sucesso!',
    workerErrors: {
      invalidParity: 'Paridade incorreta para o tamanho do grid.',
      noUniqueSolution:
        'Não foi possível encontrar uma Solução Única após o limite de tentativas.',
    },
  },
};
